export default __webpack_public_path__ + "static/media/users_v2.92e25153.svg";